import React, { useRef, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Optional: if you want annotation plugin
// import annotationPlugin from "chartjs-plugin-annotation";

// Register chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
//   annotationPlugin
);

const AreaChart = () => {
  const chartRef = useRef(null);

  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Invoiced",
        data: [4500, 4200, 4300, 4000, 2500, 1000, 2200, 900, 440, 220, 1500, 4000],
        fill: true,
        backgroundColor: "rgba(99, 102, 241, 0.1)", // soft fill
        borderColor: "rgba(99, 102, 241, 1)",       // blue border
        borderWidth: 2,
        tension: 0.2,
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHoverBackgroundColor: "#6366f1",
        pointHoverBorderColor: "#fff",
        pointHoverBorderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#111",
        borderColor: "#ddd",
        borderWidth: 1,
        padding: 10,
        displayColors: false,
        callbacks: {
          title: (items) => items[0].label,
          label: (item) => "Invoiced: $" + item.formattedValue,
        },
      },
      annotation: {
        annotations: {
          line1: {
            type: "line",
            xMin: "Apr",
            xMax: "Apr",
            borderColor: "rgba(99,102,241,0.8)",
            borderWidth: 2,
            borderDash: [6, 6],
          },
        },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true, grid: { color: "rgba(0,0,0,0.05)" } },
    },
  };

  return (
    <div style={{ height: "350px", width: "100%" }}>
      <Line ref={chartRef} data={data} options={options} />
    </div>
  );
};

export default AreaChart;
